import React, {
  useEffect, useRef, useState
} from 'react';

import Carousel from '../../../components/prescriptive/complex/Carousel';
import { getString } from '../../../helpers/string-helpers';
import ExploreMorePost from './explore-more/ExporeMorePost';

const ExploreMore = ({ locale, posts }) => {
  const prevArrow = useRef(null);
  const nextArrow = useRef(null);
  const [carouselCurrentSlide, setCarouselCurrentSlide] = useState(0);

  useEffect(() => {
    const postCount = (posts ?? []).length;

    if (postCount === 0) {
      return;
    }

    const onClickPrev = () => {
      window.carouselPrev();
    };
    const onClickNext = () => {
      window.carouselNext();
    };

    prevArrow.current.addEventListener('click', onClickPrev);
    nextArrow.current.addEventListener('click', onClickNext);

    return () => {
      if (prevArrow?.current && nextArrow?.current) {
        prevArrow.current.removeEventListener('click', onClickPrev);
        nextArrow.current.removeEventListener('click', onClickNext);
      }
    };
  }, []);

  return (
    <div className="ExploreMore wrapper bg-secondary-eggshell py-80">
      <div className="grid max-w-100% mx-auto xsx:w-93% sm:w-[79%] md:w-93% blog-lg:max-w-[1276px] blog-lg:w-100%">
        <div className="row">
          <div className="column  flex justify-between pb-22 w-100% items-end">
            <div className="wrapper">
              <h2 className="font-semibold font-body text-22 md:text-30">
                {getString('exploreMoreText', locale)}
              </h2>
            </div>

            <div className="wrapper hidden items-end sm:flex">
              <div
                ref={prevArrow}
                className={`wrapper active:opacity-50 mr-12 rotate-180 ${
                  posts.length > 3 ? '' : 'hidden'
                }`}
                data-prev="true"
              >
                <div className="imagex mb-24 w-100%">
                  <img

                    loading="lazy"
                    src="https://rippling.imgix.net/images/S8oGtGrQ-Right.svg"
                  />
                </div>
              </div>

              <div
                ref={nextArrow}
                className={`wrapper active:opacity-50 ${
                  posts.length > 3 ? '' : 'hidden'
                }`}
                data-next="true"
              >
                <div className="imagex mb-24 w-100%">
                  <img

                    loading="lazy"
                    src="https://rippling.imgix.net/images/S8oGtGrQ-Right.svg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="wrapper flex flex-col justify-between">
          <div>
            <div className="progressBar mb-16">
              {posts.length > 3 ? (
                <span
                  className="progressBar__highlight bg-black z-1000 bottom-1 absolute h-1 right-0 scale-0 w-100%"
                  style={{
                    transform: `scaleX(${
                      (carouselCurrentSlide + 1) / posts.length
                    })`,
                  }}
                />
              ) : null}
              <span className="progressBar__base bg-[#DDDDDD] bottom-1 absolute h-1 right-0 w-100%" />
            </div>
          </div>
        </div>
      </div>

      <div
        className={`grid max-w-100% ${
          posts.length > 3 ? ' xsx:ml-auto xsx:mr-0' : ' mx-auto'
        } overflow-hidden relative xsx:w-93% sm:w-[79%] md:w-93% blog-lg:max-w-[1276px] blog-lg:w-100%`}
      >
        <div className="row w-100% mt-48">
          <div className="column">
            <div className="grid max-w-[1276px] w-100%">
              <div className="row flex h-100% w-100%">
                {posts.length > 3 ? (
                  <div className="column xsx:mb-48 xsx:w-[348px] sm:w-[433px]">
                    <div>
                      <Carousel
                        attributes={{ numOfSlidesInContainer: 3 }}
                        setCarouselCurrentSlide={setCarouselCurrentSlide}
                      >
                        {posts.map((post, postIndex) => {
                          return (
                            <div
                              key={postIndex}
                              className="mr-24 text-left group multiLine-draw-card"
                            >
                              <ExploreMorePost locale={locale} post={post} />
                            </div>
                          );
                        })}
                      </Carousel>
                    </div>
                  </div>
                ) : (
                  <div
                    className={`display-grid grid-cols-1  md:grid-cols-${posts.length} gap-24`}
                  >
                    {posts.map((post, postIndex) => (
                      <div
                        key={postIndex}
                        className="column xsx:mb-48 w-100% text-left group multiLine-draw-card"
                      >
                        <ExploreMorePost locale={locale} post={post} />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreMore;
